/*
 * @Author: sail web admin
 * @Date: 2020-04-23 16:20:30
 * @Last Modified by: vicshang
 * @Last Modified time: 2020-09-29 15:27:46
 * 简体中文文案
 */
import common from './common';
import login from './login';

export default {
  CurrentLan: '当前语言',
  SystemName: '系统管理后台脚手架',
  HomePage: '首页',
  UserManager: '借款用户管理',
  UserList: '用户列表',
  UserInfo: '用户信息',
  ProjectManager: '项目管理',
  ProjectList: '项目列表',
  CreateProject: '发布项目',
  ApplyLoan: '借款申请',
  RiskAudit: '风控审核',
  LoanOrder: '借款订单',
  OrderList: '订单列表',
  RepaymentList: '还款流水',
  WithdrawalList: '交易流水',
  RepaymentPlanList: '还款计划',
  SystemManager: '系统管理',
  SystemUser: '用户管理',
  RoleManager: '角色管理',
  PromissionManager: '权限管理',
  Login: '登录',
  TestManager: '测试案例',
  // 公共
  Common: common,
  // 登录
  LoginModule: login
};
